class GetTimeDiference {
    private static start: number;
    private static end: number;

    public static startTimer() {
        this.start = new Date().getTime();
    }

    public static endTimer() {
        this.end = new Date().getTime();
    }

    public static getTimeDiference() {
        return (this.end - this.start) / 1000;
    }
}

//removeIf(production)
export default GetTimeDiference;
//endRemoveIf(production)